import React, { FunctionComponent } from 'react';

import { Modal } from 'components';
import { Text } from 'components/chroma';

export const WhenAnswerYesModal: FunctionComponent<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => (
  <Modal header="When to answer yes?" isOpen={isOpen} onClose={onClose}>
    <Text>
      Answer &#39;Yes&#39; if the car is used more than once a week, on average,
      for business. Driving to and from your place of work is not considered
      business purposes.
    </Text>
  </Modal>
);

export default WhenAnswerYesModal;
